module.exports = __webpack_public_path__ + "static/media/error.7bbb7bb4.svg";